export enum MarginOfSafetyLevel {
  Great = "Great",
  Caution = "Caution",
  Low = "Low",
}

/**
 * New-UI buffer state (BCAD-543). Drives the buffer-doodat character and
 * background gradient on the redesigned Margin of Safety page. Maps 1:1 onto
 * the existing score levels: Great → good, Caution → warning, Low → critical.
 */
export type MarginOfSafetyState = "good" | "warning" | "critical";

export interface MarginOfSafetyThreshold {
  level: MarginOfSafetyLevel;
  minScore: number;
  maxScore: number;
  theme: string;
  /** Buffer-doodat character asset — the new UI renders it as the large
   *  centred character; the legacy UI shows it via <svg-icon>. */
  imageSrc: string;
  message: string;
  /** New-UI state key — selects the background gradient. */
  state: MarginOfSafetyState;
}

export const MARGIN_OF_SAFETY_THRESHOLDS: MarginOfSafetyThreshold[] = [
  {
    level: MarginOfSafetyLevel.Great,
    minScore: 10,
    maxScore: Infinity,
    theme: "body",
    imageSrc: "assets/icons/icon-buffer-doodat-green.svg",
    message:
      "<div>Your Safety Buffer is nice and big right now. That's wonderful! Remember you can keep it strong and green by including a wide variety of safety cards in today's plan.</div>",
    state: "good",
  },
  {
    level: MarginOfSafetyLevel.Caution,
    minScore: 1,
    maxScore: 9,
    theme: "sunbeam",
    imageSrc: "assets/icons/icon-buffer-doodat-amber.svg",
    message:
      "<div>Your Safety Buffer isn't very robust right now. No need to stress though! This is a sign that you need to add some extra safety cards into your plan. If possible, you should also think about dropping some activities to help expand your buffer and get you back towards green.</div>",
    state: "warning",
  },
  {
    level: MarginOfSafetyLevel.Low,
    minScore: -Infinity,
    maxScore: 0,
    theme: "campfire",
    imageSrc: "assets/icons/icon-buffer-doodat-red.svg",
    message:
      "<div> It looks like you don't have a very big Safety Buffer at the moment. You should think about only doing the things you absolutely need to today, and fill your day with lots of safety. <br/> <br/> <strong>Don't forget you can access your Flare-Up plan at any time using the Sanctuary button.</strong></div>",
    state: "critical",
  },
];
